import { CdkTrapFocus } from '@angular/cdk/a11y';
import { Directive, input, model, Optional } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { isNotNullish } from '@examdojo/util/nullish';
import { debounceTime, EMPTY, filter, first, Observable, switchMap, tap } from 'rxjs';
import { SwiperStepperComponent } from '../swiper-stepper';

@Directive({
  selector: 'swiper-slide',
  standalone: true,
  hostDirectives: [CdkTrapFocus],
})
export class SwiperSlideDirective {
  constructor(@Optional() private readonly parentSwiperStepperComponent?: SwiperStepperComponent<FormGroup>) {
    this.updateSwiperHeightEffect().pipe(takeUntilDestroyed()).subscribe();
  }

  readonly controlName = input<string | undefined>();
  readonly skip = model<boolean>(false);
  readonly updateSwiperHeightOnEmission = input<Observable<unknown>>();

  readonly controlName$ = toObservable(this.controlName);

  private updateSwiperHeightEffect() {
    const parentSwiperStepperComponent = this.parentSwiperStepperComponent;
    if (!parentSwiperStepperComponent) {
      return EMPTY;
    }

    return toObservable(this.updateSwiperHeightOnEmission).pipe(
      filter(isNotNullish),
      switchMap((observable) => observable),
      debounceTime(100), // we don't want to update the height too often
      switchMap(() => parentSwiperStepperComponent.swiperInstance$.pipe(first(isNotNullish))),
      tap((swiperInstance) => {
        swiperInstance.updateAutoHeight();
      }),
    );
  }
}
